<template>
    <div class="youkexianxiaxingweifenxi">
        <IconList :rankList="chartData" :marginBottom="0.2"/>
    </div>
</template>

<script>
    import IconList from "@/components/Mycharts/IconList.vue";

    export default {
        name: "RemenChengshi",
        components: {
            IconList
        },
        data() {
            return {
                chartData: [],
            };
        },
        mounted() {
            // 居民出游城市top10
            fetch("/data/JuminChuyou/citytopten.json")
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    this.chartData = json.data;
                });
        }
    };
</script>
<style scoped lang="less"></style>
